import Vue from 'vue';

const manipulation_helpers = {
	state: {
    
	},

  get_human_datetime: function(the_date, tz_offset) {
    // EXPECTS "Mon Feb 07 2011 11:05:00 GMT" FORMAT FOR IE AND SAFARI

    if(the_date) {

      let tz = 'EDT';
      if(tz_offset != '-0400') {
        tz = 'EST';
      }

      return the_date += ' ' + tz;
      
    }
    
  },

  check_timestamp_diff: function(timestamp, compare_to) {
    // INIT
    let result = {}
    let diff = parseInt(compare_to) - parseInt(timestamp);

    // CHECK IF RESULT IS LESS THAN OR GREATER THAN 0
    if(diff < 0) {
      result.sign = '-'
    }
    else {
      result.sign = '+'
    }

    // GET ABSOLUTE VALUE FOR TEMPORAL DISTANCE MEASURMENT
    diff = Math.abs(diff);

    // DETERMINE VARIOUS TEMPORAL DISTANCES FROM "COMPARE_TO"
    result.ms = diff;
    result.seconds = (diff / 1000);
    result.minutes = (diff / (1000 * 60));
    result.hours = (diff / (1000 * 60 * 60));
    result.days = (diff / (1000 * 60 * 60 * 24));

    return result;
  }
  
}

export default manipulation_helpers


// WEBPACK FOOTER //
// ./src/store/modules/mod_manipulation_helpers.js